// src/Camera.js
import React, {useEffect, useState, useRef} from 'react';
import {useLocation,useNavigate,Link,useParams} from 'react-router-dom'
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import html2canvas from 'html2canvas';
import { BiSolidLeftArrow, BiSolidRightArrow } from 'react-icons/bi';
import {CgSoftwareDownload} from 'react-icons/cg';
import jsonData from '../template.json'

import '../App.css';
import '../ResultTemplate.css';
import { sendAnalyticsData } from '../utilities/analytics';

import Cookies from 'universal-cookie';
const cookies = new Cookies();

const resultAPI = process.env.REACT_APP_RESULT_TEMPLATE;

// console.log(jsonData)
const SlickButton = ({currentSlide, slideCount, children, ...props}) => (
  <a {...props}>{children}</a>
);

const arrowSlider = {
  nextArrow: 
    <SlickButton className="slick-arrow slick-next">
        <BiSolidRightArrow/>
    </SlickButton>,
  prevArrow: 
    <SlickButton className="slick-arrow slick-prev">
        <BiSolidLeftArrow/>
    </SlickButton>
}

const settingsLipsSection = {
  dots: false,
  infinite: false,
  accessibility: true,
  arrows: true,
  speed: 800,
  autoplaySpeed: 3000,
  slidesToShow: 1,
  ...arrowSlider
};

// Helper function to chunk array into groups of size n
function chunkArray(array, size) {
  return array.reduce((acc, _, i) => (i % size ? acc : [...acc, array.slice(i, i + size)]), []);
}


const RenderProductsLipsMobile = ({data = []}) => {
  
  const settingsProduct = {
    dots: false,
    infinite: false,
    accessibility: true,
    arrows: true,
    speed: 800,
    autoplaySpeed: 3000,
    slidesToShow: 3,
    ...arrowSlider
  };

  if (data.length !== 0) {
    return (
      <>
        <div className='list-product-lips' key={JSON.stringify(data)}>
          {data.map((category, index) => {
            return (
              <div className='list-product pb-4 pb-md-2' key={index}>
                <div className="title-category-image w-100 text-center">
                  <img src={category.categoryImage} alt=''/>
                </div>
                
                <Slider key={index} className='product-slider' {...settingsProduct}>
                  {category.item.map((item, itemIndex) => (
                    <div key={itemIndex} className='product-slide'>
                      <a className='image-product' href={item.link} target='_blank' onClick={()=>{sendAnalyticsData('Click',`Product ${item.link}`)}}>
                        {item.image ?
                          <img src={item.image} alt='' />
                          :
                          <span className='bg-dark'>No data for this season</span>
                        }
                      </a>
                    </div>
                  ))}
                </Slider>
              </div>
            )
          })}
        </div>
      </>
    );
  }

  return null;
}

const RenderProductsLips = ({ data = [] }) => {
  const settingsProduct = {
    dots: false,
    infinite: false,
    accessibility: true,
    arrows: true,
    speed: 800,
    autoplaySpeed: 3000,
    slidesToShow: 3,
    ...arrowSlider
  };
  if (data.length !== 0) {

    console.log(data.length)
    var groupedData = data;

    if(data.length > 4){
      groupedData = chunkArray(data, 4);
      return (
        <Slider className='slider-lips-section product-slider' {...settingsLipsSection}>
          {groupedData.map((group, groupIndex) => (
            <div className="wrapper-section-lips" key={groupIndex}>
              {group.map((category, index) => (
                <div className='list-product pb-4 pb-md-2' key={index}>
                  <div className="title-category-image text-center">
                    <img src={category.categoryImage} alt='' />
                  </div>
                  <Slider key={index} className='product-slider' {...settingsProduct}>
                    {category.item.map((item, itemIndex) => (
                      <div key={itemIndex} className='product-slide'>
                        <a className='image-product' href={item.link} target='_blank' onClick={() => { sendAnalyticsData('Click', `Product ${item.link}`) }}>
                          {item.image ?
                            <img src={item.image} alt='' />
                            :
                            <span className='bg-dark'>No data for this season</span>
                          }
                        </a>
                      </div>
                    ))}
                  </Slider>
                </div>
              ))}
            </div>
          ))}
        </Slider>
      );
    }else{
      return(
        groupedData.map((group, groupIndex) => (
          <div className='list-product pb-4 pb-md-2' key={groupIndex}>
            <div className="title-category-image text-center">
              <img src={group.categoryImage} alt='' />
            </div>
            <Slider key={groupIndex} className='product-slider' {...settingsProduct}>
              {group.item.map((item, itemIndex) => (
                <div key={itemIndex} className='product-slide'>
                  <a className='image-product' href={item.link} target='_blank' onClick={() => { sendAnalyticsData('Click', `Product ${item.link}`) }}>
                    {item.image ?
                      <img src={item.image} alt='' />
                      :
                      <span className='bg-dark'>No data for this season</span>
                    }
                  </a>
                </div>
              ))}
            </Slider>
          </div>
        ))
      )
    }
  }

  return null;
}

const RenderProductsBlushOn = ({data = []}) => {
  const settingsProduct = {
    dots: false,
    infinite: false,
    accessibility: false,
    arrows: true,
    speed: 800,
    autoplaySpeed: 3000,
    slidesToShow: 3,
    ...arrowSlider
  };

  if (data.length !== 0) {
    return (
      <Slider key={JSON.stringify(data)} className='product-slider' {...settingsProduct}>
        {data.map((item, itemIndex) => (
          <div key={itemIndex} className='product-slide'>
            <a className='image-product' href={item.link} target='_blank' onClick={()=>{sendAnalyticsData('Click',`Product ${item.link}`)}}>
              {item.image ?
                <img src={item.image} alt='' />
                :
                <span className='bg-dark'>No data for this season</span>
              }
            </a>
            <p><span className='d-block' style={{marginBottom: '2px'}}>{item.category}</span> <strong>{item.code}</strong> {item.name}</p>
          </div>
        ))}
      </Slider>
    );
  }

  return null;
};

const RenderProductsEyes = ({data = [], isMobile}) => {
  const settingsProduct = {
    dots: false,
    infinite: false,
    accessibility: false,
    arrows: true,
    adaptiveHeight: true,
    speed: 800,
    autoplaySpeed: 3000,
    slidesToShow: 1,
    ...arrowSlider
  };

  if (data.length !== 0) {
    if(isMobile){
      return(
        <>
          {data.map((item, itemIndex) => (
            <div key={itemIndex} className='product-eye pb-4 pb-md-2'>
              <div className="title-category-image d-table mb-3 mx-auto">
                <img src={item.categoryImage} alt=''/>
              </div>
              {item.item.map((i, index) => (
                <a href={i.link} target='_blank' onClick={()=>{sendAnalyticsData('Click',`Product ${i.link}`)}} key={index} className='w-100 text-center d-block mb-2' style={{aspectRatio: 'unset'}}>
                  {i.image ?
                    <img src={i.image} alt='' />
                    :
                    <span className='bg-dark'>No data for this season</span>
                  }
                </a>
              ))}
            </div>
          ))}
        </>
      )
    }else{
      return (
        <Slider key={JSON.stringify(data)} className='product-slider' {...settingsProduct}>
          {data.map((item, itemIndex) => (
            <div key={itemIndex} className='product-slide'>
              <div className="title-category-image d-table mb-3 mx-auto">
                <img src={item.categoryImage} alt=''/>
              </div>
              {item.item.map((i, index) => (
                <a href={i.link} onClick={()=>{sendAnalyticsData('Click',`Product ${i.link}`)}} target='_blank' key={index} className='image-product d-block mb-2' style={{aspectRatio: 'unset'}}>
                  {i.image ?
                    <img style={{'width': '80%'}} src={i.image} alt='' />
                    :
                    <span className='bg-dark'>No data for this season</span>
                  }
                </a>
              ))}
            </div>
          ))}
        </Slider>
      );
    }
  }

  return null;
};

const RenderProductComplexion = ({data = [], slidesToShow}) => {
  const settingsProduct = {
    dots: false,
    infinite: false,
    accessibility: false,
    arrows: true,
    adaptiveHeight: true,
    speed: 800,
    autoplaySpeed: 3000,
    slidesToShow: slidesToShow,
    ...arrowSlider
  };

  if (data.length !== 0) {
    return (
      <Slider key={JSON.stringify(data)} className='product-slider' {...settingsProduct}>
        {data.map((item, itemIndex) => (
          <div key={itemIndex} className='product-slide'>
            <a className='image-product d-flex mb-2' href={item.link} onClick={()=>{sendAnalyticsData('Click',`Product ${item.link}`)}} target='_blank'>
              {item.image ?
                <img src={item.image} style={{'width': '92%'}} alt='' />
                :
                <span className='bg-dark ratio-1x1'></span>
              }
            </a>
          </div>
          ))}
      </Slider>
    );
  }

  return null;
};

const RenderProductComplexionMobile = ({data = []}) => {
  if (data.length !== 0) {
    const filteredItems = data.filter(item => item.type === 'complexion' && item.category === 'cushion');
    return (
      <div 
        key={JSON.stringify(data)} 
        className="product-slider mb-4"  
        style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', alignItems: 'end'}}
      >
        {data.map((item, itemIndex) => {
          if (item.type === 'complexion' && item.category === 'cushion') {
            return (
              <>
                <a
                  key={itemIndex}
                  className="item-big image-product d-flex mb-4" style={{'width': '50%', 'padding': '0 10px'}}
                  href={item.link}
                  onClick={() => sendAnalyticsData('Click', `Product ${item.link}`)}
                >
                  {item.image ? (
                    <img src={`${item.image}?withheaders=`} width="100%" alt="" />
                  ) : (
                    <span className="bg-dark ratio-1x1"></span>
                  )}
                  
                  {itemIndex === 0 ? (
                    <p className='desc' style={{backgroundColor: '#A5B4A1'}} dangerouslySetInnerHTML={{ __html: 'More cover & soft matte finish<br/>18H Longlasting & SPF 50 PA +++<br/>Infused with CICA & Nano Hyaluron' }} />
                  ) : itemIndex === 1 ? (
                    <p className='desc' dangerouslySetInnerHTML={{ __html: 'Smooth glow finish<br/>12H Longlasting & SPF 40 PA +++<br/>Infused with CICA & Hydra Beta Glucan' }} />
                  ) : null}
                </a>
                {filteredItems.length === 1 ? <div className='w-100'></div>: null}
              </>
            );
          }

          if (item.type === 'complexion') {
            return (
              <a
                key={itemIndex}
                className="image-product d-flex" style={{'width': '33%', 'padding': '0 10px'}}
                href={item.link}
                onClick={() => sendAnalyticsData('Click', `Product ${item.link}`)}
              >
                {item.image ? (
                  <img src={`${item.image}?withheaders=`} width="100%" alt="" />
                ) : (
                  <span className="bg-dark ratio-1x1"></span>
                )}
              </a>
            );
          }
          return null; // Explicitly return null for items not matching the condition
        })}
      </div>
    );
  }

  return null;
};

const RenderProductComplexionLightening = ({data = []}) => {
  console.log(data);
  if (data.length !== 0) {
    return (
      <div 
      className="product-slider mb-4"  
      style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', alignItems: 'end' }}
      >
        {data.map((item, itemIndex) => {
          if (item.type === 'lightening') {
            return (
              <a key={itemIndex} className='image-product' style={{'width': '33%', 'padding': '0 10px'}} href={item.link}>
                {item.image ?
                  <img src={item.image+'?withheaders='} width="100%" alt='' />
                  :
                  <span className='bg-dark ratio-1x1'></span>
                }
              </a>
            );
          }
          return null; // Explicitly return null for items not matching the condition
        })}
      </div>
    );
  }

  return null;
};

const RenderPaletteGrid = ({data = [], slidesToShow, isMobile}) => {
  const settingsPaletteSlider = {
    dots: false,
    infinite: false,
    accessibility: true,
    arrows: true,
    speed: 800,
    autoplaySpeed: 3000,
    slidesToShow: slidesToShow,
    ...arrowSlider
  }
  
  if (data.length !== 0) {
    if(isMobile){
      return(
        <>
          <div className='palette-grid mb-3 mb-md-4'>
            {data.map((item, itemIndex) => (
              <div key={itemIndex} className='palette-grid-item' style={{backgroundColor: item}}></div>
            ))}
          </div>
        </>
        )
    }else{
      return(
        <Slider key={JSON.stringify(data)} className='product-slider' {...settingsPaletteSlider}>
          {data.map((item, itemIndex) => (
            <div key={itemIndex} className='product-slide'>
              <div className='palette-grid-item' style={{backgroundColor: item}}></div>
            </div>
            ))}
        </Slider>
      )
    }
  }

  return null;
};

const PageResultTemplate = () => {
  const [result, setResult] = useState({});
  const [userName, setUserName] = useState('');
  const [subSeason, setSubSeason] = useState('');
  const [complexion, setComplexion] = useState('');
  const [complexionName, setComplexionName] = useState('');
  const [complexionCode, setComplexionCode] = useState('');
  const [shareTemplate, setShareTemplate] = useState('autumn');
  const [skintoneColor, setSkintoneColor] = useState('#F3C4BF');
  const [complexionProducts, setComplexionProducts] = useState(null);
  const [shareComplexionProducts, setShareComplexionProducts] = useState('');
  const [deviceType, setDeviceType] = useState('desktop');

  const { type } = useParams();
  const navigate = useNavigate()
  const location = useLocation();

  const divRef = useRef(null);
  const canvasRef = useRef(null);
  const divElement = divRef.current;

  const mobileAndTabletCheck = () => {
    let check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);

    if(check){
      setDeviceType('mobile');
    }else{
      setDeviceType('desktop');
    }

    console.log(deviceType);
  };

  useEffect(() => {
    mobileAndTabletCheck();

    if(location.state === null){
      navigate('/');
      return;
    }
    let name = location.state.name 
    let sub_season = location.state.subseasonal 
    let skintone = location.state.skintone 
    let seasonal = location.state.seasonal
    let tmpComplexion = location.state.complexionName.split(' ')[0]

    setSkintoneColor(skintone)
    setComplexionCode(tmpComplexion)
    setComplexionName(location.state.complexionName.substr(4,location.state.complexionName.length))
    setComplexion(location.state.complexionName)
    setUserName(name)
    setSubSeason(sub_season)

    // fetch(resultAPI)
    //   .then((response) => response.json())
    //   .then((jsonData) => {
        let complexionIndex =  jsonData.complexion.findIndex(object => (object.code === tmpComplexion)) || 0;
        let resultData = {};
        if(type==='expert'){
          setShareTemplate(sub_season);

          if (sub_season === 'summer') {
            resultData = jsonData.season[2];
          } else if (sub_season === 'winter') {
            resultData = jsonData.season[3];
          } else if (sub_season === 'spring') {
            resultData = jsonData.season[0];
          } else if (sub_season === 'autumn') {
            resultData = jsonData.season[1];
          }  
        }else if(type==='basic'){  
          setShareTemplate(seasonal);

          let tmpJSON1 
          let tmpJSON2
          if(seasonal==='warm'){
            resultData=JSON.parse(JSON.stringify(jsonData.season[0]))
            tmpJSON1=jsonData.season[0];
            tmpJSON2 = jsonData.season[1];
            resultData.headerBG = 'https://personalcolor.wardahbeauty.com/fetch/assets/images/header/warm.png'

          }else{
            resultData=JSON.parse(JSON.stringify(jsonData.season[2]))
            tmpJSON1=jsonData.season[2];
            tmpJSON2 = jsonData.season[3];
            resultData.headerBG = 'https://personalcolor.wardahbeauty.com/fetch/assets/images/header/cool.png'
          }
          resultData.lips[0].item = tmpJSON1.lips[0].item.concat(tmpJSON2.lips[0].item)
          resultData.lips[1].item = tmpJSON1.lips[1].item.concat(tmpJSON2.lips[1].item)
          resultData.lips[2].item = tmpJSON1.lips[2].item.concat(tmpJSON2.lips[2].item)
          resultData.lips[3].item = tmpJSON1.lips[3].item.concat(tmpJSON2.lips[3].item)
          resultData.lips[4].item = tmpJSON1.lips[4].item.concat(tmpJSON2.lips[4].item)
          resultData.lips[5].item = tmpJSON1.lips[4].item.concat(tmpJSON2.lips[5].item)
          // resultData.lips.push(tmpJSON2.lips[5])

          resultData.palette = tmpJSON1.palette.concat(tmpJSON2.palette)
          
        }
        setResult(resultData);
        setComplexionProducts(jsonData.complexion[complexionIndex].item)
        setShareComplexionProducts(jsonData.complexion[complexionIndex].share_products)
        
      // })
      // .catch((error) => console.error('Error fetching data:', error));
      // sendAnalyticsData('View Page','Result Template Page')
  }, []);

  const handleConvertToCanvas = () => {
    html2canvas(divElement, {
      "scale": 2
    }).then(async(canvas) => {
      var data = canvas.toDataURL('image/jpeg');

      if (navigator.share) {
        try {
          await navigator.share({
            files: [new File([await (await fetch(data)).blob()], 'image.jpeg', { type: 'image/jpeg' })]
          });
          sendAnalyticsData('Click','Share Button')
        } catch (error) {
          console.error('Error sharing:', error);
        }
      }
    });
  };

  const handleDownloadCanvas = () => {
    html2canvas(divElement, {
      "scale": 2
    }).then((canvas) => {
      var data = canvas.toDataURL('image/jpeg');
      const a = document.createElement('a');
      a.href = data;
      // a.target = '_blank';
      a.download = shareTemplate+'.jpeg';
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      sendAnalyticsData('Click','Download Button')
    });
  };

  return (
    <>
      <div className='result-container result-container-mobile d-block d-md-none'>
        <div className="header-container d-flex justify-content-between" style={{backgroundImage: `url(${result.headerBG})`}}>
          <img className="personal" src="/images/personal.png" />
          <div className="logo-container w-50 d-flex flex-column align-items-end justify-content-start">
            <img src="/images/logo-template.png" />
            <div className="my-0 me-0">
              <div className="wardah-text header-your-name mb-2">{userName}</div>
              <div className="w-100 bg-white" style={{height: '1px'}} />
            </div>
          </div>
        </div>
        <div className='d-block d-md-flex d-sm-flex justify-content-center'>
          <div className='column-palette-wrapper d-block d-md-flex flex-column vw-100 flex-grow-1 justify-content-end'>
            <div className="palette-container d-md-flex align-items-start">
              <div className="section-title d-table mt-4" style={{minWidth: '146px'}}>COLOR PALETTES</div>
              <div className='palette-grid-wrapper'>
                <RenderPaletteGrid data={result.palette} slidesToShow={5} isMobile={true}/>
              </div>
            </div>
            <div className="complexion-container vw-100 d-flex justify-end align-items-center flex-column">
              {console.log(complexionProducts)}
              {
                complexionProducts ? 
                <>
                  <div className='d-flex align-items-center gap-1 gap-md-2 w-100 ps-2'>
                    <div className="section-title-container flex-grow-1">
                      <img src="/images/title-complexion.png" />
                    </div>
                    <div className='section-palette-container d-flex align-items-center me-0 me-md-3 mt-1'>
                      <div className='d-flex align-items-center justify-content-end gap-1 gap-md-2 d-none'>
                        <div className="palette" style={{backgroundColor: skintoneColor}}></div>
                        <div className="wardah-text">{complexion}</div>
                      </div>
                    </div>
                  </div>
                  <div className='complexion-products-slider mt-4 mb-3' style={{ maxWidth: 'unset', width: 'auto' }}>
                    {/* <RenderProductComplexion data={complexionProducts} slidesToShow={3}/> */}
                    <RenderProductComplexionMobile data={complexionProducts} />
                  </div>
                </>
                : null
              }

              {
                complexionProducts ? 
                <>
                  <div className='d-flex align-items-center gap-1 gap-md-2 w-100 ps-2'>
                    <div className="section-title-container flex-grow-1">
                      <img style={{ maxWidth: '49.5%' }} src="/images/complexion-lightening-title.png" alt="Complexion Title" />
                    </div>
                  </div>
                  
                  <div className='complexion-products-slider mt-4' style={{ maxWidth: 'unset', width: 'auto' }}>
                    <RenderProductComplexionLightening data={complexionProducts} />
                  </div>
                </>
                :
                null
              }
              
            </div>
          </div>
          {/* <div className="ecommerce-container px-3 d-none d-md-flex flex-column align-items-center justify-content-center text-center">
            <img width='140' src='/images/title-get-yours.png' className='mb-3' alt=''/>
            <p>
              <a id='shop-btn' className='btn' href='#' target='_blank'>Shop Now</a>
            </p>
          </div> */}
        </div>
        <div className='d-block d-md-flex flex-wrap'>
          <div className="category-product-section wardah-box-md lips-section position-relative">
            <div className="lips-title wardah-text text-white d-block d-md-none text-center">MAKEUP THAT SUITS YOU BEST</div>
              <div className="section-title-container d-table mt-4 mx-auto" style={{width: '21%'}}>
                <img src="/images/title-lips.png" />
            </div>
            <RenderProductsLipsMobile data={result.lips} />
          </div>
          <div className="category-product-section wardah-box-md eyes-section wardah-bg-light pb-2">
            <div className="section-title-container mt-5 mb-3 d-table mx-auto" style={{width: '26%'}}>
              <img src="/images/title-eye.png" />
            </div>
              <RenderProductsEyes data={result.eyes} isMobile={true}/>
          </div>
          <div className="category-product-section blushon-section mb-4">
            <div className="section-title-container d-table mt-5 mb-4 mx-auto" style={{width: '38%'}}>
              <img src="/images/title-blushon.png" />
            </div>
              <RenderProductsBlushOn data={result.blushOn} />
          </div>
          <div className="ecommerce-container mt-4 pt-3 pb-3 px-2 d-block d-md-none text-center">
            <img width='140' src='/images/title-get-yours.png' className='mb-3' alt=''/>
            <p>
              <a id='shop-btn-desktop' className='btn d-none d-lg-table' href='https://www.wardahbeauty.com/id/product/list/make-up' onClick={()=>{sendAnalyticsData('Click',`https://www.wardahbeauty.com/id/product/list/make-up`)}} target='_blank'>SHOP NOW</a>
            </p>
          </div>
        </div>
        <div className="ecommerce-container d-block d-md-none">
          <div className="ecommerce-title wardah-text text-white">SHOP YOUR BEAUTY MATCH!</div>
          <div className="ecommerce-button-container bg-white mx-auto my-0">
            <a href="https://www.wardahbeauty.com/id/product/list/sale/sort/makeup" className="ecommerce-button wardah" target='_blank' onClick={()=>{sendAnalyticsData('Click',`Wardah Website`)}} ><img className="w-100 h-100" src="/images/wardah.png" /></a>
            <a href="https://shopee.co.id/wardahofficial?categoryId=100630&entryPoint=ShopByPDP&itemId=3010539954" target='_blank' onClick={()=>{sendAnalyticsData('Click',`Shopee Website`)}}  className="ecommerce-button shopee"><img className="w-100 h-100" src="/images/shopee.png" /></a>
            {/* <a href="http://www.tiktok.com/" className="ecommerce-button tiktok" target='_blank'><img className="w-100 h-100" src="/images/tiktok.png" /></a> */}
            <a href="https://www.lazada.co.id/shop/wardah-ofc-store/?itemId=4640860337&spm=a2o4j.pdp_revamp.seller.1.44693987x1jJwM&path=promotion-39695-0.htm&tab=promotion&channelSource=pdp" target='_blank' onClick={()=>{sendAnalyticsData('Click',`Lazada Website`)}}  className="ecommerce-button lazada"><img className="w-100 h-100" src="/images/lazada.png" /></a>
            <a href="https://www.tokopedia.com/wardah-official" className="ecommerce-button tokopedia" target='_blank' onClick={()=>{sendAnalyticsData('Click',`Tokopedia Website`)}} ><img className="w-100 h-100" src="/images/tokped.png" /></a>
          </div>
        </div>
        <div className='d-flex justify-content-center gap-2 my-2'>
          <button id="share-btn" className='result-action btn' onClick={handleConvertToCanvas}>SHARE</button>
          <a href={`/?event_name=${!cookies.get('event_name') ? '' : cookies.get('event_name')}`} className='result-action btn'>FINISH</a>
        </div>
      </div>
      
      <div className='result-container result-container-desktop d-none d-md-block'>
        <div className='result-wrapper d-block d-md-flex d-sm-flex justify-content-between flex-wrap'>
          <div className='d-block d-md-block section-result-left'>
            <div className='d-block d-md-flex d-sm-flex justify-content-center'>
              <div className="header-container position-relative d-flex justify-content-between d-sm-none d-md-flex" style={{backgroundImage: `url(${result.headerBG})`}}>
                <img className="personal" src="/images/personal.png" />
                <div className="logo-container w-50 d-flex flex-column align-items-end justify-content-start">
                  <img src="/images/logo-template.png" />
                  <div className="my-0 me-0">
                    <div className="wardah-text header-your-name mb-2">{userName}</div>
                    <div className="w-100 bg-white" style={{height: '1px'}} />
                  </div>
                </div>
              </div>
              <div className="complexion-container w-100 d-flex flex-column px-2">
                <div className="section-title-container flex-grow-1 w-100">
                  <img src="/images/title-complexion.png" />
                </div>
                <div className='section-palette-container d-flex align-items-center gap-2 gap-lg-3'>
                  <div className='skintone-name'>
                    <div className='skintone-code'>
                      <div className="palette" style={{backgroundColor: skintoneColor}}></div>
                      <span>{complexionCode}</span>
                    </div>
                    {complexionName.toUpperCase()}
                  </div>
                  <div className='complexion-products-slider'>
                    {complexionProducts ?
                      <RenderProductComplexion data={complexionProducts} slidesToShow={1}/>
                      :
                      null
                    }
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="ecommerce-container px-3 d-none d-md-flex flex-column align-items-center justify-content-center text-center">
              <img width='140' src='/images/title-get-yours.png' className='mb-3' alt=''/>
              <p>
                <a id='shop-btn' className='btn' href='#' target='_blank'>Shop Now</a>
              </p>
            </div> */}
            <div className="lips-section position-relative d-flex">
              <div className="lips-title wardah-text text-white d-block d-md-none text-center">MAKEUP THAT SUITS YOU BEST</div>
              <div className="section-title-container d-table d-md-none my-4 mx-auto">
                <img src="/images/title-lips.png" />
              </div>

              <div className='d-none d-md-flex justify-content-center align-items-center section-title-desktop'>
                <img src="/images/section-title-lips.png" />
              </div>
              <div className='list-product-lips'>
                <RenderProductsLips data={result.lips} />
              </div>
            </div>
          </div>
          <div className='d-block d-md-block section-result-right'>
            <div className="palette-container d-md-flex align-items-end justify-content-center flex-column">
              <div className="section-title d-table mx-auto" style={{minWidth: '140px'}}>COLOR PALETTES</div>
              <div className='palette-grid-wrapper right-side-board px-0 mt-3'>
                <div className="palette-grid mt-md-1">
                  <RenderPaletteGrid data={result.palette} slidesToShow={10}/>
                </div>
              </div>
            </div>
            <div className="category-product-section eyes-section d-md-flex justify-content-between align-items-center right-side-board pb-1" style={{borderRadius: '80px 0 0 80px'}}>
              <div className="section-title-container" style={{width: '20%'}}>
                <img src="/images/title-eye.png" />
              </div>
              <div className='eyes-slider-wrapper'>
                <RenderProductsEyes data={result.eyes} />
              </div>
            </div>
            <div className="category-product-section blushon-section d-md-flex justify-content-between align-items-center right-side-board" style={{borderRadius: '80px 0 0 80px'}}>
              <div className="section-title-container" style={{width: '27%'}}>
                <img src="/images/title-blushon.png" />
              </div>
              <div className='blushon-slider-wrapper'>
                <RenderProductsBlushOn data={result.blushOn} />
              </div>
            </div>
            <div className="ecommerce-container pb-2 px-2 mt-xl-5 d-none d-md-flex text-center align-items-center w-100">
              <img src='/images/title-get-yours.png' className='get-yours-image ms-2 me-2' alt=''/>
              {/* <a id='shop-btn' className='btn me-2' href='https://www.wardahbeauty.com/id/product/list/make-up' target='_blank'>SHOP NOW</a> */}

              <div className="ecommerce-button-container ecommerce-container-desktop mx-auto gap-1 gap-md-2 py-0 ms-0">
                <a href="https://www.wardahbeauty.com/id/product/list/sale/sort/makeup" target='_blank' onClick={()=>{sendAnalyticsData('Click',`Wardah Website`)}} className="ecommerce-button wardah"><img className="w-100 h-100" src="/images/wardah.png" /></a>
                <a href="https://shopee.co.id/wardahofficial?categoryId=100630&entryPoint=ShopByPDP&itemId=3010539954" target='_blank' onClick={()=>{sendAnalyticsData('Click',`Shopee Website`)}} className="ecommerce-button shopee"><img className="w-100 h-100" src="/images/shopee.png" /></a>
                {/* <a href="http://www.tiktok.com/" className="ecommerce-button tiktok"><img className="w-100 h-100" src="/images/tiktok.png" /></a> */}
                <a href="https://www.lazada.co.id/shop/wardah-ofc-store/?itemId=4640860337&spm=a2o4j.pdp_revamp.seller.1.44693987x1jJwM&path=promotion-39695-0.htm&tab=promotion&channelSource=pdp" target='_blank' onClick={()=>{sendAnalyticsData('Click',`Lazada Website`)}} className="ecommerce-button lazada"><img className="w-100 h-100" src="/images/lazada.png" /></a>
                <a href="https://www.tokopedia.com/wardah-official" target='_blank' onClick={()=>{sendAnalyticsData('Click',`Tokopedia Website`)}} className="ecommerce-button tokopedia"><img className="w-100 h-100" src="/images/tokped.png" /></a>
              </div>
              {deviceType && deviceType === 'desktop' ?
                <a id="download-btn-desktop" className='d-flex align-items-center ms-auto' onClick={handleDownloadCanvas}>
                  DOWNLOAD
                  <span>
                    <CgSoftwareDownload/>
                  </span>
                </a>
                :  
                <button id="share-btn" className='result-action btn my-0' onClick={handleConvertToCanvas}>SHARE</button>
              }
            </div>
          </div>
            
          <div className='w-100 d-flex align-items-center justify-content-center mt-2'>
            <a href={`/?event_name=${!cookies.get('event_name') ? '' : cookies.get('event_name')}`} className='result-action btn' style={{'width': '164px'}}>FINISH</a>
          </div>
        </div>
      </div>
      
      <div ref={divRef} className='share-template-wrapper position-fixed' style={{zIndex: '-1', aspectRatio: '9/16', width: '430px', height: '920px'}}>
        <div className='share-template position-relative'>
          <img className='w-100' src={`/images/share-templates/${shareTemplate}.jpg`} alt=''/>
          
          <p className='share-template-username'>{userName}</p>
          <img className='share-complexion-product' src={`/images/share-templates/${shareComplexionProducts}`} alt=''/>
        </div>
      </div>
      <div ref={canvasRef}></div>
    </>
  );
};

export default PageResultTemplate;
